import CustomModal from "../CustomModal";

function LocationStatusModal({ isOpen, onRequestClose, title, description, buttonText = "Cancel", onButtonClick = null, type = "success" }) {
  const getImagePath = () => {
    switch (type) {
      case "success":
        return "/images/thumbs-up.png";
      case "warning":
        return "/images/delete-danger.png";
      case "info":
        return "/images/info-circle.png";
      default:
        return "/images/thumbs-up.png";
    }
  };

  const handleButtonClick = () => {
    if (onButtonClick) {
      onButtonClick();
    } else {
      onRequestClose();
    }
  };

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="edit-success-modal"
      contentLabel={`${title} Modal`}
    >
      <img
        src={`${process.env.PUBLIC_URL}${getImagePath()}`}
        alt={
          type === "success"
            ? "Success thumbs up icon"
            : type === "warning"
            ? "Warning icon"
            : type === "info"
            ? "Information icon"
            : "Status icon"
        }
      />
      <h2 style={{ fontWeight: "500" }}>{title}</h2>
  {description && <p style={{ textAlign: 'center' }}>{description}</p>}
      <button type="button" onClick={handleButtonClick}>
        {buttonText}
      </button>
    </CustomModal>
  );
}

export default LocationStatusModal;
